import { Suspense } from "react";
import {
  BrowserRouter,
  Navigate,
  Routes as ReactRoutes,
  Route,
} from "react-router-dom";
import { useAuth} from "@/hooks/Auth";
import PublicRoutes, { OpenRoutes, PUBLIC_PATHS } from "./publicRoutes";
import PrivateRoutes from "./privateRoutes";

type ModuleRouteProps = {
  signed?: boolean;
};

const ModuleRoute = ({ signed }: ModuleRouteProps) => {
  return (
    <ReactRoutes>
      {/* Aberta nos dois estados: quem está logado também precisa alcançá-la. */}
      {OpenRoutes({})}
      {signed ? (
        <>
          {PrivateRoutes({})}
          <Route path="*" element={<Navigate to="/" />} />
        </>
      ) : (
        <>
          {PublicRoutes({})}
          <Route path="*" element={<Navigate to={PUBLIC_PATHS.SIGN_IN} />} />
        </>
      )}
    </ReactRoutes>
  );
};

const Routes = () => {
  const { signed } = useAuth();

  return (
    <BrowserRouter>
      <Suspense>
        <ModuleRoute signed={signed} />
      </Suspense>
    </BrowserRouter>
  );
};

export default Routes;
